/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const V1CoachApplicationStatus = {
    COACH_APP_NONE: 'none',
    COACH_APP_PENDING: 'pending',
    COACH_APP_APPROVED: 'approved',
    COACH_APP_DECLINED: 'declined'
} as const
export type V1CoachApplicationStatus =
    (typeof V1CoachApplicationStatus)[keyof typeof V1CoachApplicationStatus]

export function instanceOfV1CoachApplicationStatus(value: any): boolean {
    for (const key in V1CoachApplicationStatus) {
        if (
            Object.prototype.hasOwnProperty.call(V1CoachApplicationStatus, key)
        ) {
            if (
                V1CoachApplicationStatus[
                    key as keyof typeof V1CoachApplicationStatus
                ] === value
            ) {
                return true
            }
        }
    }
    return false
}

export function V1CoachApplicationStatusFromJSON(
    json: any
): V1CoachApplicationStatus {
    return V1CoachApplicationStatusFromJSONTyped(json, false)
}

export function V1CoachApplicationStatusFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1CoachApplicationStatus {
    return json as V1CoachApplicationStatus
}

export function V1CoachApplicationStatusToJSON(
    value?: V1CoachApplicationStatus | null
): any {
    return value as any
}

export function V1CoachApplicationStatusToJSONTyped(
    value: any,
    ignoreDiscriminator: boolean
): V1CoachApplicationStatus {
    return value as V1CoachApplicationStatus
}
